module.exports = __webpack_public_path__ + "static/media/Gulf Bank 1.358363f6.jpg";